import { useContext, useEffect, useState } from 'react';
import * as t from 'io-ts';
import { decode } from '../../server/lib/codec';
import CustomComponentContext from '../components/CustomComponentContext';

const sublimeDeliveryInstructionsEnabledV = t.strict(
  {
    enabled: t.boolean,
  },
  'sublimeDeliveryInstructionsEnabledV',
);

function useSublimeDeliveryInstructions() {
  const [status, setStatus] = useState<
    'pending' | 'enabled' | 'disabled' | 'rejected'
  >('pending');

  const { state } = useContext(CustomComponentContext);
  const { carrier, trackingNumbers, retailerMoniker, orderNumbers } =
    state?.pageContext || {};

  const trackingNumber = trackingNumbers?.[0];
  const orderNumber = orderNumbers?.[0];

  useEffect(() => {
    const reqBody = {
      attributes: {
        track_retailerMoniker: retailerMoniker,
        track_trackingNumber: trackingNumber ?? 'undefined',
        track_orderNumber: orderNumber
          ? `o-${retailerMoniker}-${orderNumber}`
          : `t-${carrier ?? 'undefined'}-${trackingNumber ?? 'undefined'}`,
      },
    };

    (async () => {
      const url = '/api/v1/growthbook/sublime-delivery-instructions';
      const response = await fetch(url, {
        method: 'POST',
        body: JSON.stringify(reqBody),
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        setStatus('disabled');
        return;
      }

      const body: unknown = await response.json();
      const { enabled } = decode(sublimeDeliveryInstructionsEnabledV, body);

      setStatus(enabled ? 'enabled' : 'disabled');
    })().catch((err) => {
      // eslint-disable-next-line no-console
      console.error(err);
      setStatus('rejected');
    });
  }, [carrier, orderNumber, trackingNumber, retailerMoniker]);

  return { isEnabled: status === 'enabled', status };
}

// eslint-disable-next-line import/prefer-default-export
export { useSublimeDeliveryInstructions };
